import React from 'react';
import './css/steps.css';
import BackImg from './images/services/4.jpg'
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const ConstructionSteps = () => {
  const { language } = useLanguage();
  const { content } = useContent();
  
  const tag = content?.steps
    ? (language === 'ar' ? content.steps.tag_ar : content.steps.tag_en)
    : (language === 'ar' ? 'كيفية التنفيذ' : 'How We Work');
  
  const title = content?.steps
    ? (language === 'ar' ? content.steps.title_ar : content.steps.title_en)
    : (language === 'ar' ? 'خطوات عملية العمل الإنشائي' : 'Construction Work Process Steps');
  
  const description = content?.steps
    ? (language === 'ar' ? content.steps.description_ar : content.steps.description_en)
    : (language === 'ar' ? 'نتبع منهجية دقيقة تبدأ من استلام الموقع مرورًا بأعمال التصميم والتطوير وحتى الإشراف الكامل على التنفيذ لضمان أعلى مستويات الجودة في كل مرحلة.' : 'We follow a precise methodology that starts from site handover, through design and development work, to full supervision of implementation to ensure the highest levels of quality at every stage.');
  
  const stepLabel = content?.steps
    ? (language === 'ar' ? content.steps.step_label_ar : content.steps.step_label_en)
    : (language === 'ar' ? 'خطوة' : 'Step');
  
  const steps = content?.stepsItems || [];
  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net';
    return `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`;
  };
  
  const bgImage = content?.steps?.background_image_url 
    ? getImageUrl(content.steps.background_image_url)
    : BackImg;

  return (
    <section className="construction-section" dir="rtl">
      <div className="construction-container">
        <div className="construction-content">
          {/* Right Side - Text Content */}
          <div className="content-right">
            <div className="content-tag">{tag}</div>
            <h2 className="content-title">
              {title}
            </h2>
            <p className="content-description">
              {description}
            </p>
          </div>

          {/* Left Side - Image */}
          <div className="content-left">
            <div className="image-wrapper">
              <img 
                src={bgImage} 
                alt="Construction Workers" 
                className="construction-image"
              />
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>

        {/* Steps Section */}
        <div className="steps-container">
          {steps.length > 0 ? (
            steps.map((step, index) => (
              <div className="step-card" key={step.id || index}>
                <div className="step-line-wrapper">
                  <div className="step-line"></div>
                  <div className="step-dot"></div>
                </div>
                <div className="step-content">
                  <div className="step-header">
                    <span className="step-number">{step.step_id || step.id}</span>
                    <span className="step-label">{stepLabel}</span>
                  </div>
                  <h3 className="step-title">{language === 'ar' ? step.title_ar : step.title_en}</h3>
                  <p className="step-description">{language === 'ar' ? step.description_ar : step.description_en}</p>
                </div>
              </div>
            ))
          ) : (
            // Fallback steps if no data from API
            language === 'ar' ? (
              <>
                <div className="step-card">
                  <div className="step-line-wrapper">
                    <div className="step-line"></div>
                    <div className="step-dot"></div>
                  </div>
                  <div className="step-content">
                    <div className="step-header">
                      <span className="step-number">01</span>
                      <span className="step-label">{stepLabel}</span>
                    </div>
                    <h3 className="step-title">استلام الموقع</h3>
                    <p className="step-description">يتم استلام الموقع رسميًا وتجهيزه بإزالة العوائق، وتحديد النقاط المرجعية وإعداد المساحة للعمل.</p>
                  </div>
                </div>
                <div className="step-card">
                  <div className="step-line-wrapper">
                    <div className="step-line"></div>
                    <div className="step-dot"></div>
                  </div>
                  <div className="step-content">
                    <div className="step-header">
                      <span className="step-number">02</span>
                      <span className="step-label">{stepLabel}</span>
                    </div>
                    <h3 className="step-title">التطوير والإنشاء</h3>
                    <p className="step-description">تبدأ عملية التنفيذ العملي من حفر الأساسات، وصب الخرسانة، ورفع الهيكل وفق المخططات الهندسية المعتمدة.</p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="step-card">
                  <div className="step-line-wrapper">
                    <div className="step-line"></div>
                    <div className="step-dot"></div>
                  </div>
                  <div className="step-content">
                    <div className="step-header">
                      <span className="step-number">01</span>
                      <span className="step-label">{stepLabel}</span>
                    </div>
                    <h3 className="step-title">Site Handover</h3>
                    <p className="step-description">The site is officially received and prepared by removing obstacles, identifying reference points and preparing the space for work.</p>
                  </div>
                </div>
                <div className="step-card">
                  <div className="step-line-wrapper">
                    <div className="step-line"></div>
                    <div className="step-dot"></div>
                  </div>
                  <div className="step-content">
                    <div className="step-header">
                      <span className="step-number">02</span>
                      <span className="step-label">{stepLabel}</span>
                    </div>
                    <h3 className="step-title">Development and Construction</h3>
                    <p className="step-description">The practical implementation process begins from digging foundations, pouring concrete, and erecting the structure according to approved engineering plans.</p>
                  </div>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
    
  );
};

export default ConstructionSteps;
